// N38 · Phase 2 — 自学习别名表（localStorage.activityAliases，{ catId: [别名...] }）
// 追问"算哪个分类？"和复述卡[改]纠正映射都写这里；matchActivity 的 extraAliases 从这读。
// 纯函数 withAlias 负责逻辑（可单测），load/learn 是 localStorage 薄壳。

const KEY = 'activityAliases';

// 把 word→catId 写进表（返回新对象，不改入参）。
// 同一个词只允许一个归属：旧映射先摘掉（纠正场景：「搬砖」从 A 改教到 B）。
export function withAlias(map, word, catId) {
  const w = String(word || '').trim().toLowerCase();
  if (!w || !catId) return map;
  const next = {};
  Object.entries(map || {}).forEach(([k, list]) => {
    const kept = (list || []).filter(a => a !== w);
    if (kept.length) next[k] = kept;
  });
  next[catId] = [...(next[catId] || []), w];
  return next;
}

export function loadAliases() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}') || {};
  } catch (e) {
    return {}; // 坏数据当空表
  }
}

export function learnAlias(word, catId) {
  const next = withAlias(loadAliases(), word, catId);
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* 存满/隐私模式：本次仍生效，只是记不住 */ }
  return next;
}
